// A successful IPC exchange can still contain a failed MCP tool invocation.
export function mcpCallFailed(response) {
  return !response || response.ok === false || response.result?.isError === true;
}
export function contextualMcpCall(plan, version) {
  return typeof version === 'number' ? { ...plan, expectedContext: version } : plan;
}
